module.exports = "<div ui-view>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ../~/noop-loader!./components/xo-credit-components/src/bml-display/template.html
 ** module id = 472
 ** module chunks = 1
 **/